import React from 'react'
import QueueBarcode from '../../components/queue/QueueBarcode'
import QueueWait from '../../components/queue/QueueWait'

export default function QueueBarcodeScreen() {
    return (
        // <div><QueueBarcode /></div>
        <div><QueueWait /></div>
    )
}
